export default "__VITE_ASSET__CEPuXKQO__"